// extracted by mini-css-extract-plugin
export default {"root":"ActiveInvoiceTable_root__WSnzf","invoice-type-wrapper":"ActiveInvoiceTable_invoice-type-wrapper__LMCx7","property-address":"ActiveInvoiceTable_property-address__8pRSD"};